import Slider from "react-slick";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import Banner from "@/components/ui/banner/Banner";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./BannerSlider.css";

interface BannerSliderProps {
  items: Array<{
    id: string;
    image: { default: string; desktop: string };
    title: React.ReactNode;
    description?: React.ReactNode;
    link?: { href: string; text: string };
  }>;
  isLoading?: boolean;
}

const settings = {
  dots: true,
  infinite: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 6000,
  slidesToShow: 1,
  lazyLoad: "anticipated" as const,
  fade: true,
  waitForAnimate: false,
};

const NextArrow = (props: { className?: string; onClick?: () => void }) => {
  const { className, onClick } = props;

  return (
    <div className={className} onClick={onClick}>
      <ChevronRightIcon className="size-6 text-white lg:size-9" />
    </div>
  );
};

const PrevArrow = (props: { className?: string; onClick?: () => void }) => {
  const { className, onClick } = props;

  return (
    <div className={className} onClick={onClick}>
      <ChevronLeftIcon className="box-content size-6 text-white lg:size-9" />
    </div>
  );
};

const BannerSlider = ({ items, isLoading = true }: BannerSliderProps) => {
  // Skeleton Shimmer
  if (isLoading) {
    return (
      <div className="flex w-full animate-pulse items-center justify-center bg-base-300 px-14">
        <div className="flex w-full max-w-screen-sm flex-col items-center gap-4 *:rounded-md *:bg-base-300">
          <div className="h-16 w-full"></div>
          <div className="mb-8 h-16 w-2/3"></div>
          <div className="h-4 w-1/2"></div>
          <div className="h-4 w-1/2"></div>
          <div className="h-4 w-1/4"></div>
        </div>
      </div>
    );
  }

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div id="banner-slider">
      <Slider {...settings} nextArrow={<NextArrow />} prevArrow={<PrevArrow />}>
        {items.map((item, index) => (
          <div key={item?.id ?? index}>{<Banner banner={item} skeletonSize="lg" />}</div>
        ))}
      </Slider>
    </div>
  );
};

export default BannerSlider;
